import React, {useCallback, useEffect, useRef, useState} from "react";

export default function DragAndDrop({children, handleFileDrop}) {
    const dropRef = useRef(null)

    const [dragging, setDragging] = useState(false)
    const [count, setCount] = useState(0)

    const handleDragIn = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        setCount((prev) => prev++)
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragging(true)
        }
    }, [])

    const handleDragOut = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        setCount((prev) => prev--)
        if (count === 0) {
            setDragging(false)
        }
    }, [count])

    const handleDrag = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
    }, [])

    const handleDrop = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        setDragging(false)
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFileDrop(e.dataTransfer.files)
            e.dataTransfer.clearData()
            setCount(0)
        }
    }, [handleFileDrop])

    useEffect(() => {
        let div = dropRef.current
        div.addEventListener('dragenter', handleDragIn)
        div.addEventListener('mouseup', handleDragOut)
        div.addEventListener('dragover', handleDrag)
        div.addEventListener('drop', handleDrop)

        return () => {
            div.removeEventListener('dragenter', handleDragIn)
            div.removeEventListener('mouseup', handleDragOut)
            div.removeEventListener('dragover', handleDrag)
            div.removeEventListener('drop', handleDrop)
        }
    }, [handleDragIn, handleDragOut, handleDrag, handleDrop]);

    return (
        <div className={"w-full h-full relative "} ref={dropRef}>
            {dragging &&
            <div
                className={"border-dashed border-4 border-light-blue-500 absolute bottom-0 left-0 right-0 top-0 bg-gray-300 bg-opacity-75 z-50"}>
                <div>
                    <div className={"flex justify-center items-center"}>drop here :)</div>
                </div>
            </div>
            }
            {children}
        </div>
    );
}